module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-51.bd45463e.jpg";